import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { class: "ai-chat-bot" }
const _hoisted_2 = { class: "ai-chat-bot-in" }
const _hoisted_3 = { class: "ai-chat-bot-btm" }
const _hoisted_4 = {
  class: "ai-chat-bot-message-list-box",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_5 = { class: "ai-chat-bot-message-list-box-in" }
const _hoisted_6 = { class: "bot-message-box-in" }
const _hoisted_7 = {
  key: 0,
  class: "message-file-preview"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "uploaded-pdf-preview"
}
const _hoisted_10 = { class: "pdf-info" }
const _hoisted_11 = { class: "pdf-filename" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "bot-message-box-action" }
const _hoisted_14 = {
  key: 0,
  class: "bot-is-typing"
}
const _hoisted_15 = { class: "ai-chat-bot-message-write-box" }
const _hoisted_16 = { class: "ai-chat-bot-message-write-box-top" }
const _hoisted_17 = { class: "ai-chat-bot-message-write-box-btm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ai-chat-bot-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openChatbot && _ctx.openChatbot(...args)))
    }, "LMD AI"),
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"ai-chat-bot-top\" data-v-4de4d513><div class=\"ai-chat-bot-top-left\" data-v-4de4d513><img src=\"" + _imports_0 + "\" alt=\"AI Chat Bot\" data-v-4de4d513><h3 data-v-4de4d513>LMD AI</h3></div><div class=\"ai-chat-bot-top-right\" data-v-4de4d513><button class=\"chat-bat-minimize-btn\" data-v-4de4d513></button><button class=\"chat-bat-zoom-btn\" data-v-4de4d513></button></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
              return (_openBlock(), _createElementBlock("div", {
                key: message.id,
                class: _normalizeClass(["bot-message-box", 
                message.is_user
                  ? 'ai-bot user_message_box'
                  : 'ai_bot_message_box'
              ])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (message.file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (message.file.type.startsWith('image/'))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: message.file.url,
                              alt: message.file.name,
                              class: "uploaded-image-preview"
                            }, null, 8, _hoisted_8))
                          : (message.file.type === 'application/pdf')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pdf-icon" }, "📄", -1)),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("p", _hoisted_11, _toDisplayString(message.file.name), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "ai-chat-bot-message-show",
                    innerHTML: _ctx.formatMessage(message.message)
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, _toDisplayString(_ctx.formatTime(message.created_at)), 1)
                    ])
                  ])
                ])
              ], 2))
            }), 128)),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Generating", -1),
                  _createElementVNode("span", null, "...", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ], 512),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userInput) = $event)),
              class: "ai-chat-bot-message-write-box-field",
              placeholder: "Type your message here...",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.sendMessage()), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.userInput]
            ]),
            _createElementVNode("button", {
              class: "send-message-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendMessage()))
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("ul", null, [
              _cache[8] || (_cache[8] = _createElementVNode("li", null, [
                _createElementVNode("button", { class: "ai-chat-bot-log-btn" })
              ], -1)),
              _createElementVNode("li", null, [
                _createElementVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                  accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
                  style: {"display":"none"}
                }, null, 544),
                (_ctx.isFileUploadEnabled)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "ai-chat-bot-attach-btn",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args)))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}